var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _defs, _g17, _defs2, _g18, _defs3, _g19, _defs4, _g20, _defs5, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _defs6, _g29, _defs7, _g30, _defs8, _g31, _animate, _animate2, _animate3, _animate4, _animate5, _animate6, _animate7, _animate8, _animate9, _animate10, _animate11, _animate12, _animate13, _animate14, _animate15, _animate16, _animate17, _animate18, _animate19, _animate20, _animate21, _animate22, _animate23, _animate24, _animate25, _animate26, _animate27, _animate28, _animate29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconnaissanceMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m6evuu1148287843",
    viewBox: "0 0 420 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1148287843_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1148287843",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1438136573_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1438136573_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1438136573",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1438136573_fill_path",
    d: "M0.01,0h419.98c0.00552,0 0.01,0.00448 0.01,0.01v249.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-419.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-249.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fillRule: "nonzero",
    fill: "rgb(255, 218, 187)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m6evuu1438136573_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1873103929_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-146.4804,-190.4384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1873103929",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1927335648_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,44.4678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1927335648",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1921635299_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4618,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1921635299",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1921635299_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1921635299_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6evuu1921635299ps0)",
    mask: "url(#m6evuu1921635299_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1d26394662_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,293.7792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1d26394662",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1d26394662_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1d26394662_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6evuu1d26394662ps0)",
    mask: "url(#m6evuu1d26394662_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1f67933369_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,204.7352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1f67933369",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1f67933369_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1f67933369_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6evuu1f67933369ps0)",
    mask: "url(#m6evuu1f67933369_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1g34357303_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,66.7031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1g34357303",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1g34357303_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1g34357303_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6evuu1g34357303ps0)",
    mask: "url(#m6evuu1g34357303_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1h85498282_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.457,376.2489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1h85498282",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1h85498282_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1h85498282_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6evuu1h85498282ps0)",
    mask: "url(#m6evuu1h85498282_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1j58695726_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,137.8496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1j58695726",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1j58695726_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1j58695726_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6evuu1j58695726ps0)",
    mask: "url(#m6evuu1j58695726_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1k87411381_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,409.1015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1k87411381",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1k87411381_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1k87411381_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6evuu1k87411381ps0)",
    mask: "url(#m6evuu1k87411381_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1l55013251_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,92.6797,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1l55013251",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1l14260036_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.6005,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1l14260036",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1l14260036_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1l14260036_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6evuu1l14260036ps0)",
    mask: "url(#m6evuu1l14260036_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1m25930197_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.6005,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1m25930197",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1m25930197_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1m25930197_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6evuu1m25930197ps0)",
    mask: "url(#m6evuu1m25930197_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1n92225279_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1n92225279",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1n92225279_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1n92225279_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6evuu1n92225279ps0)",
    mask: "url(#m6evuu1n92225279_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1o79039506_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,268.6005,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1o79039506",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1o79039506_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1o79039506_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6evuu1o79039506ps0)",
    mask: "url(#m6evuu1o79039506_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1p23375138_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,349.6005,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1p23375138",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1p23375138_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1p23375138_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6evuu1p23375138ps0)",
    mask: "url(#m6evuu1p23375138_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1q15703356_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,106.4032,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1q15703356",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1q15703356_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1q15703356_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6evuu1q15703356ps0)",
    mask: "url(#m6evuu1q15703356_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1q64004074_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,525.1611,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1q64004074",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1q64004074_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1q64004074_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6evuu1q64004074ps0)",
    mask: "url(#m6evuu1q64004074_gradient_mask)"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1s46404786_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,51,58.7646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1s46404786",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1s46404786_stroke_path",
    d: "M0,0h326.70001",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1s46404786_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -327.9,
    y: -1.2,
    width: 983.6999999999999,
    height: 3.5999999999999996,
    fill: "url(#m6evuu1s46404786ps0)",
    mask: "url(#m6evuu1s46404786_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1t80347688_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,51,59.3624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1t80347688",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1t80347688_stroke_path",
    d: "M163.8,0c0,0 0,69.3261 0,71.6462c0,2.3201 -0.3915,4.2857 -1.2785,6.4294c-0.887,2.1437 -2.0008,3.8085 -3.6422,5.4499c-1.6414,1.6414 -3.3062,2.7552 -5.4499,3.6422c-2.1437,0.887 -4.1093,1.2785 -6.4294,1.2785c-2.3201,0 -147,0 -147,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1t80347688_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -165,
    y: -89.64620000000001,
    width: 495,
    height: 268.9386,
    fill: "url(#m6evuu1t80347688ps0)",
    mask: "url(#m6evuu1t80347688_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1u68412522_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.3994,52.7883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1u68412522",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1u68412522_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1u09968821_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,209.3994,52.7883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1u09968821",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1u09968821_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1v39981421_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,371.3994,52.7883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1v39981421",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1v39981421_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1w06856334_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,290.3994,52.7883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1w06856334",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1w06856334_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1w24755581_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,19.200200000000002,19.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1w24755581",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1w24755581_fill_path",
    d: "M12.3703,0h43.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-43.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(4, 106, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6evuu1w24755581_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1w24755581_stroke_path",
    d: "M12.3703,0h43.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-43.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6evuu1w24755581_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1w24755581_stroke_path",
    d: "M12.3703,0h43.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-43.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu1w24755581_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -68.39999999999999,
    y: -25.340600000000002,
    width: 205.2,
    height: 76.02180000000001,
    fill: "url(#m6evuu1w24755581ps0)",
    mask: "url(#m6evuu1w24755581_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1w85440373_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu1w85440373",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu1w85440373_fill_path",
    d: "M3.21105,3.2992c0.704,0 1.3216,0.1376 1.8528,0.4128c0.5376,0.2752 0.9504,0.6688 1.2384,1.1808c0.2944,0.5056 0.4416,1.0944 0.4416,1.7664c0,0.672 -0.1472,1.2608 -0.4416,1.7664c-0.288,0.4992 -0.7008,0.8864 -1.2384,1.1616c-0.5312,0.2752 -1.1488,0.4128 -1.8528,0.4128h-2.3424v-6.7008zM3.16305,8.8576c0.704,0 1.248,-0.192 1.632,-0.576c0.384,-0.384 0.576,-0.9248 0.576,-1.6224c0,-0.6976 -0.192,-1.2416 -0.576,-1.632c-0.384,-0.3968 -0.928,-0.5952 -1.632,-0.5952h-0.9504v4.4256zM10.1115,10.0864c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4096,-0.2304 -0.7328,-0.5536 -0.9696,-0.9696c-0.2304,-0.416 -0.3456,-0.896 -0.3456,-1.44c0,-0.544 0.1184,-1.024 0.3552,-1.44c0.2432,-0.416 0.5728,-0.736 0.9888,-0.96c0.416,-0.2304 0.88,-0.3456 1.392,-0.3456c0.512,0 0.976,0.1152 1.392,0.3456c0.416,0.224 0.7424,0.544 0.9792,0.96c0.2432,0.416 0.3648,0.896 0.3648,1.44c0,0.544 -0.1248,1.024 -0.3744,1.44c-0.2432,0.416 -0.576,0.7392 -0.9984,0.9696c-0.416,0.224 -0.8832,0.336 -1.4016,0.336zM10.1115,8.9152c0.2432,0 0.4704,-0.0576 0.6816,-0.1728c0.2176,-0.1216 0.3904,-0.3008 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5248 0.192,-0.864c0,-0.5056 -0.1344,-0.8928 -0.4032,-1.1616c-0.2624,-0.2752 -0.5856,-0.4128 -0.9696,-0.4128c-0.384,0 -0.7072,0.1376 -0.9696,0.4128c-0.256,0.2688 -0.384,0.656 -0.384,1.1616c0,0.5056 0.1248,0.896 0.3744,1.1712c0.256,0.2688 0.576,0.4032 0.96,0.4032zM20.4766,4.6048c0.6528,0 1.1776,0.2016 1.5744,0.6048c0.4032,0.3968 0.6048,0.9536 0.6048,1.6704v3.12h-1.344v-2.9376c0,-0.416 -0.1056,-0.7328 -0.3168,-0.9504c-0.2112,-0.224 -0.4992,-0.336 -0.864,-0.336c-0.3648,0 -0.656,0.112 -0.8736,0.336c-0.2112,0.2176 -0.3168,0.5344 -0.3168,0.9504v2.9376h-1.344v-2.9376c0,-0.416 -0.1056,-0.7328 -0.3168,-0.9504c-0.2112,-0.224 -0.4992,-0.336 -0.864,-0.336c-0.3712,0 -0.6656,0.112 -0.8832,0.336c-0.2112,0.2176 -0.3168,0.5344 -0.3168,0.9504v2.9376h-1.344v-5.3184h1.344v0.6432c0.1728,-0.224 0.3936,-0.4 0.6624,-0.528c0.2752,-0.128 0.576,-0.192 0.9024,-0.192c0.416,0 0.7872,0.0896 1.1136,0.2688c0.3264,0.1728 0.5792,0.4224 0.7584,0.7488c0.1728,-0.3072 0.4224,-0.5536 0.7488,-0.7392c0.3328,-0.1856 0.6912,-0.2784 1.0752,-0.2784zM23.5856,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM27.7712,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM31.119,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM31.7814,4.6816v5.3184h-1.344v-5.3184zM36.0565,4.6048c0.6336,0 1.1456,0.2016 1.536,0.6048c0.3904,0.3968 0.5856,0.9536 0.5856,1.6704v3.12h-1.344v-2.9376c0,-0.4224 -0.1056,-0.7456 -0.3168,-0.9696c-0.2112,-0.2304 -0.4992,-0.3456 -0.864,-0.3456c-0.3712,0 -0.6656,0.1152 -0.8832,0.3456c-0.2112,0.224 -0.3168,0.5472 -0.3168,0.9696v2.9376h-1.344v-5.3184h1.344v0.6624c0.1792,-0.2304 0.4064,-0.4096 0.6816,-0.5376c0.2816,-0.1344 0.5888,-0.2016 0.9216,-0.2016z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2108062960_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,94.2002,70.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2108062960",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2108062960_fill_path",
    d: "M12.3703,0h61.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-61.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(4, 106, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6evuu2108062960_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2108062960_stroke_path",
    d: "M12.3703,0h61.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-61.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6evuu2108062960_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2108062960_stroke_path",
    d: "M12.3703,0h61.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-61.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2108062960_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -86.39999999999999,
    y: -25.340600000000002,
    width: 259.2,
    height: 76.02180000000001,
    fill: "url(#m6evuu2108062960ps0)",
    mask: "url(#m6evuu2108062960_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2277068923_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2277068923",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2277068923_fill_path",
    d: "M3.28605,3.2992c0.704,0 1.3216,0.1376 1.8528,0.4128c0.5376,0.2752 0.9504,0.6688 1.2384,1.1808c0.2944,0.5056 0.4416,1.0944 0.4416,1.7664c0,0.672 -0.1472,1.2608 -0.4416,1.7664c-0.288,0.4992 -0.7008,0.8864 -1.2384,1.1616c-0.5312,0.2752 -1.1488,0.4128 -1.8528,0.4128h-2.3424v-6.7008zM3.23805,8.8576c0.704,0 1.248,-0.192 1.632,-0.576c0.384,-0.384 0.576,-0.9248 0.576,-1.6224c0,-0.6976 -0.192,-1.2416 -0.576,-1.632c-0.384,-0.3968 -0.928,-0.5952 -1.632,-0.5952h-0.9504v4.4256zM13.5561,10h-1.344l-3.0432,-4.5984v4.5984h-1.344v-6.7104h1.344l3.0432,4.608v-4.608h1.344zM17.1979,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.2512,0.1696 1.68,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.0656,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.3584,0.1792 -0.784,0.2688 -1.2768,0.2688zM26.4778,10l-1.4784,-2.6112h-0.6336v2.6112h-1.344v-6.7008h2.5152c0.5184,0 0.96,0.0928 1.3248,0.2784c0.3648,0.1792 0.6368,0.4256 0.816,0.7392c0.1856,0.3072 0.2784,0.6528 0.2784,1.0368c0,0.4416 -0.128,0.8416 -0.384,1.2c-0.256,0.352 -0.6368,0.5952 -1.1424,0.7296l1.6032,2.7168zM24.3658,6.3808h1.1232c0.3648,0 0.6368,-0.0864 0.816,-0.2592c0.1792,-0.1792 0.2688,-0.4256 0.2688,-0.7392c0,-0.3072 -0.0896,-0.544 -0.2688,-0.7104c-0.1792,-0.1728 -0.4512,-0.2592 -0.816,-0.2592h-1.1232zM34.1158,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM32.7238,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM34.7512,7.3408c0,-0.5504 0.112,-1.0304 0.336,-1.44c0.224,-0.416 0.5344,-0.736 0.9312,-0.96c0.3968,-0.2304 0.8512,-0.3456 1.3632,-0.3456c0.6592,0 1.2032,0.1664 1.632,0.4992c0.4352,0.3264 0.7264,0.7872 0.8736,1.3824h-1.4496c-0.0768,-0.2304 -0.208,-0.4096 -0.3936,-0.5376c-0.1792,-0.1344 -0.4032,-0.2016 -0.672,-0.2016c-0.384,0 -0.688,0.1408 -0.912,0.4224c-0.224,0.2752 -0.336,0.6688 -0.336,1.1808c0,0.5056 0.112,0.8992 0.336,1.1808c0.224,0.2752 0.528,0.4128 0.912,0.4128c0.544,0 0.8992,-0.2432 1.0656,-0.7296h1.4496c-0.1472,0.576 -0.4384,1.0336 -0.8736,1.3728c-0.4352,0.3392 -0.9792,0.5088 -1.632,0.5088c-0.512,0 -0.9664,-0.112 -1.3632,-0.336c-0.3968,-0.2304 -0.7072,-0.5504 -0.9312,-0.96c-0.224,-0.416 -0.336,-0.8992 -0.336,-1.4496zM43.2334,10.0864c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4096,-0.2304 -0.7328,-0.5536 -0.9696,-0.9696c-0.2304,-0.416 -0.3456,-0.896 -0.3456,-1.44c0,-0.544 0.1184,-1.024 0.3552,-1.44c0.2432,-0.416 0.5728,-0.736 0.9888,-0.96c0.416,-0.2304 0.88,-0.3456 1.392,-0.3456c0.512,0 0.976,0.1152 1.392,0.3456c0.416,0.224 0.7424,0.544 0.9792,0.96c0.2432,0.416 0.3648,0.896 0.3648,1.44c0,0.544 -0.1248,1.024 -0.3744,1.44c-0.2432,0.416 -0.576,0.7392 -0.9984,0.9696c-0.416,0.224 -0.8832,0.336 -1.4016,0.336zM43.2334,8.9152c0.2432,0 0.4704,-0.0576 0.6816,-0.1728c0.2176,-0.1216 0.3904,-0.3008 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5248 0.192,-0.864c0,-0.5056 -0.1344,-0.8928 -0.4032,-1.1616c-0.2624,-0.2752 -0.5856,-0.4128 -0.9696,-0.4128c-0.384,0 -0.7072,0.1376 -0.9696,0.4128c-0.256,0.2688 -0.384,0.656 -0.384,1.1616c0,0.5056 0.1248,0.896 0.3744,1.1712c0.256,0.2688 0.576,0.4032 0.96,0.4032zM48.3377,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM50.5293,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM54.7149,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2329438177_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,165.5996,19.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2329438177",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2329438177_fill_path",
    d: "M12.3703,0h74.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-74.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(4, 106, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6evuu2329438177_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2329438177_stroke_path",
    d: "M12.3703,0h74.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-74.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6evuu2329438177_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2329438177_stroke_path",
    d: "M12.3703,0h74.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-74.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2329438177_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -99.39999999999999,
    y: -25.340600000000002,
    width: 298.2,
    height: 76.02180000000001,
    fill: "url(#m6evuu2329438177ps0)",
    mask: "url(#m6evuu2329438177_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2405286326_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2405286326",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2405286326_fill_path",
    d: "M3.04006,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.2512,0.1696 1.68,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.0656,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.3584,0.1792 -0.784,0.2688 -1.2768,0.2688zM8.89006,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.25124,0.1696 1.68004,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.47844c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.06564,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.35844,0.1792 -0.78404,0.2688 -1.27684,0.2688zM13.7705,8.9344h2.208v1.0656h-3.552v-6.7008h1.344zM18.7938,6.64c0,-0.6592 0.1472,-1.248 0.4416,-1.7664c0.3008,-0.5248 0.7072,-0.9312 1.2192,-1.2192c0.5184,-0.2944 1.0976,-0.4416 1.7376,-0.4416c0.7488,0 1.4048,0.192 1.968,0.576c0.5632,0.384 0.9568,0.9152 1.1808,1.5936h-1.5456c-0.1536,-0.32 -0.3712,-0.56 -0.6528,-0.72c-0.2752,-0.16 -0.5952,-0.24 -0.96,-0.24c-0.3904,0 -0.7392,0.0928 -1.0464,0.2784c-0.3008,0.1792 -0.5376,0.4352 -0.7104,0.768c-0.1664,0.3328 -0.2496,0.7232 -0.2496,1.1712c0,0.4416 0.0832,0.832 0.2496,1.1712c0.1728,0.3328 0.4096,0.592 0.7104,0.7776c0.3072,0.1792 0.656,0.2688 1.0464,0.2688c0.3648,0 0.6848,-0.08 0.96,-0.24c0.2816,-0.1664 0.4992,-0.4096 0.6528,-0.7296h1.5456c-0.224,0.6848 -0.6176,1.2192 -1.1808,1.6032c-0.5568,0.3776 -1.2128,0.5664 -1.968,0.5664c-0.64,0 -1.2192,-0.144 -1.7376,-0.432c-0.512,-0.2944 -0.9184,-0.7008 -1.2192,-1.2192c-0.2944,-0.5184 -0.4416,-1.1072 -0.4416,-1.7664zM31.433,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM30.041,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM33.758,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM37.86,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM40.6987,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM41.3611,4.6816v5.3184h-1.344v-5.3184zM45.1274,5.7856h-0.9312v4.2144h-1.3632v-4.2144h-0.6048v-1.104h0.6048v-0.2688c0,-0.6528 0.1856,-1.1328 0.5568,-1.44c0.3712,-0.3072 0.9312,-0.4512 1.68,-0.432v1.1328c-0.3264,-0.0064 -0.5536,0.048 -0.6816,0.1632c-0.128,0.1152 -0.192,0.3232 -0.192,0.624v0.2208h0.9312zM46.6799,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM47.3423,4.6816v5.3184h-1.344v-5.3184zM48.3246,7.3408c0,-0.5504 0.112,-1.0304 0.336,-1.44c0.224,-0.416 0.5344,-0.736 0.9312,-0.96c0.3968,-0.2304 0.8512,-0.3456 1.3632,-0.3456c0.6592,0 1.2032,0.1664 1.632,0.4992c0.4352,0.3264 0.7264,0.7872 0.8736,1.3824h-1.4496c-0.0768,-0.2304 -0.208,-0.4096 -0.3936,-0.5376c-0.1792,-0.1344 -0.4032,-0.2016 -0.672,-0.2016c-0.384,0 -0.688,0.1408 -0.912,0.4224c-0.224,0.2752 -0.336,0.6688 -0.336,1.1808c0,0.5056 0.112,0.8992 0.336,1.1808c0.224,0.2752 0.528,0.4128 0.912,0.4128c0.544,0 0.8992,-0.2432 1.0656,-0.7296h1.4496c-0.1472,0.576 -0.4384,1.0336 -0.8736,1.3728c-0.4352,0.3392 -0.9792,0.5088 -1.632,0.5088c-0.512,0 -0.9664,-0.112 -1.3632,-0.336c-0.3968,-0.2304 -0.7072,-0.5504 -0.9312,-0.96c-0.224,-0.416 -0.336,-0.8992 -0.336,-1.4496zM54.0996,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM58.2852,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM62.5163,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM69.6173,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM68.2253,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2576020773_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,258.5996,70.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2576020773",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2576020773_fill_path",
    d: "M12.3703,0h50.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-50.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(4, 106, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6evuu2576020773_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2576020773_stroke_path",
    d: "M12.3703,0h50.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-50.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6evuu2576020773_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2576020773_stroke_path",
    d: "M12.3703,0h50.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-50.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2576020773_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -75.39999999999999,
    y: -25.340600000000002,
    width: 226.2,
    height: 76.02180000000001,
    fill: "url(#m6evuu2576020773ps0)",
    mask: "url(#m6evuu2576020773_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2622874761_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2622874761",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2622874761_fill_path",
    d: "M2.19702,4.384v1.68h2.256v1.0656h-2.256v1.776h2.544v1.0944h-3.888v-6.7104h3.888v1.0944zM8.9096,4.6048c0.6336,0 1.1456,0.2016 1.536,0.6048c0.3904,0.3968 0.5856,0.9536 0.5856,1.6704v3.12h-1.344v-2.9376c0,-0.4224 -0.1056,-0.7456 -0.3168,-0.9696c-0.2112,-0.2304 -0.4992,-0.3456 -0.864,-0.3456c-0.3712,0 -0.6656,0.1152 -0.8832,0.3456c-0.2112,0.224 -0.3168,0.5472 -0.3168,0.9696v2.9376h-1.344v-5.3184h1.344v0.6624c0.1792,-0.2304 0.4064,-0.4096 0.6816,-0.5376c0.2816,-0.1344 0.5888,-0.2016 0.9216,-0.2016zM11.9637,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM16.1493,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM22.447,5.4496c0.1728,-0.2432 0.4096,-0.4448 0.7104,-0.6048c0.3072,-0.1664 0.656,-0.2496 1.0464,-0.2496c0.4544,0 0.864,0.112 1.2288,0.336c0.3712,0.224 0.6624,0.544 0.8736,0.96c0.2176,0.4096 0.3264,0.8864 0.3264,1.4304c0,0.544 -0.1088,1.0272 -0.3264,1.4496c-0.2112,0.416 -0.5024,0.7392 -0.8736,0.9696c-0.3648,0.2304 -0.7744,0.3456 -1.2288,0.3456c-0.3904,0 -0.736,-0.08 -1.0368,-0.24c-0.2944,-0.16 -0.5344,-0.3616 -0.72,-0.6048v3.2928h-1.344v-7.8528h1.344zM25.2598,7.3216c0,-0.32 -0.0672,-0.5952 -0.2016,-0.8256c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2112,-0.1216 -0.4416,-0.1824 -0.6912,-0.1824c-0.2432,0 -0.4736,0.064 -0.6912,0.192c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2368 -0.192,0.5152 -0.192,0.8352c0,0.32 0.064,0.5984 0.192,0.8352c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.1216 0.448,0.1824 0.6912,0.1824c0.2496,0 0.48,-0.064 0.6912,-0.192c0.2176,-0.128 0.3904,-0.3104 0.5184,-0.5472c0.1344,-0.2368 0.2016,-0.5184 0.2016,-0.8448zM29.9709,10.0864c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4096,-0.2304 -0.7328,-0.5536 -0.9696,-0.9696c-0.2304,-0.416 -0.3456,-0.896 -0.3456,-1.44c0,-0.544 0.1184,-1.024 0.3552,-1.44c0.2432,-0.416 0.5728,-0.736 0.9888,-0.96c0.416,-0.2304 0.88,-0.3456 1.392,-0.3456c0.512,0 0.976,0.1152 1.392,0.3456c0.416,0.224 0.7424,0.544 0.9792,0.96c0.2432,0.416 0.3648,0.896 0.3648,1.44c0,0.544 -0.1248,1.024 -0.3744,1.44c-0.2432,0.416 -0.576,0.7392 -0.9984,0.9696c-0.416,0.224 -0.8832,0.336 -1.4016,0.336zM29.9709,8.9152c0.2432,0 0.4704,-0.0576 0.6816,-0.1728c0.2176,-0.1216 0.3904,-0.3008 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5248 0.192,-0.864c0,-0.5056 -0.1344,-0.8928 -0.4032,-1.1616c-0.2624,-0.2752 -0.5856,-0.4128 -0.9696,-0.4128c-0.384,0 -0.7072,0.1376 -0.9696,0.4128c-0.256,0.2688 -0.384,0.656 -0.384,1.1616c0,0.5056 0.1248,0.896 0.3744,1.1712c0.256,0.2688 0.576,0.4032 0.96,0.4032zM34.4128,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM35.0752,4.6816v5.3184h-1.344v-5.3184zM39.3502,4.6048c0.6336,0 1.1456,0.2016 1.536,0.6048c0.3904,0.3968 0.5856,0.9536 0.5856,1.6704v3.12h-1.344v-2.9376c0,-0.4224 -0.1056,-0.7456 -0.3168,-0.9696c-0.2112,-0.2304 -0.4992,-0.3456 -0.864,-0.3456c-0.3712,0 -0.6656,0.1152 -0.8832,0.3456c-0.2112,0.224 -0.3168,0.5472 -0.3168,0.9696v2.9376h-1.344v-5.3184h1.344v0.6624c0.1792,-0.2304 0.4064,-0.4096 0.6816,-0.5376c0.2816,-0.1344 0.5888,-0.2016 0.9216,-0.2016zM44.3147,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2767202312_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,340.2002,19.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2767202312",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2767202312_fill_path",
    d: "M12.3703,0h45.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-45.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(4, 106, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6evuu2767202312_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2767202312_stroke_path",
    d: "M12.3703,0h45.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-45.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6evuu2767202312_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2767202312_stroke_path",
    d: "M12.3703,0h45.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-45.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2767202312_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -70.39999999999999,
    y: -25.340600000000002,
    width: 211.2,
    height: 76.02180000000001,
    fill: "url(#m6evuu2767202312ps0)",
    mask: "url(#m6evuu2767202312_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2743556334_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2743556334",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2743556334_fill_path",
    d: "M5.58737,5.3152c-0.1536,-0.2816 -0.36479,-0.496 -0.6336,-0.6432c-0.26879,-0.1472 -0.58239,-0.2208 -0.94079,-0.2208c-0.39681,0 -0.74881,0.0896 -1.05601,0.2688c-0.3072,0.1792 -0.5472,0.4352 -0.72,0.768c-0.1728,0.3328 -0.2592,0.7168 -0.2592,1.152c0,0.448 0.0864,0.8384 0.2592,1.1712c0.1792,0.3328 0.4256,0.5888 0.7392,0.768c0.3136,0.1792 0.6784,0.2688 1.0944,0.2688c0.512,0 0.9312,-0.1344 1.2576,-0.4032c0.32641,-0.2752 0.54081,-0.656 0.6432,-1.1424h-2.304v-1.0272h3.62881v1.1712c-0.0896,0.4672 -0.2816,0.8992 -0.576,1.296c-0.2944,0.3968 -0.6752,0.7168 -1.1424,0.96c-0.46081,0.2368 -0.9792,0.3552 -1.55521,0.3552c-0.6464,0 -1.232,-0.144 -1.7568,-0.432c-0.5184,-0.2944 -0.928,-0.7008 -1.2288,-1.2192c-0.29439,-0.5184 -0.44159,-1.1072 -0.44159,-1.7664c0,-0.6592 0.1472,-1.248 0.44159,-1.7664c0.3008,-0.5248 0.7104,-0.9312 1.2288,-1.2192c0.5248,-0.2944 1.1072,-0.4416 1.74721,-0.4416c0.7552,0 1.41119,0.1856 1.968,0.5568c0.5568,0.3648 0.9408,0.88 1.152,1.5456zM8.97213,4.048c-0.23681,0 -0.43521,-0.0736 -0.59521,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.59521,-0.2304c0.2368,0 0.432,0.0768 0.58559,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.15359,0.1472 -0.34879,0.2208 -0.58559,0.2208zM9.63453,4.6816v5.3184h-1.34401v-5.3184zM12.5272,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM19.967,4.6048c0.4032,0 0.7616,0.0896 1.0752,0.2688c0.3136,0.1728 0.5568,0.432 0.7296,0.7776c0.1792,0.3392 0.2688,0.7488 0.2688,1.2288v3.12h-1.344v-2.9376c0,-0.4224 -0.1056,-0.7456 -0.3168,-0.9696c-0.2112,-0.2304 -0.4992,-0.3456 -0.864,-0.3456c-0.3712,0 -0.6656,0.1152 -0.8832,0.3456c-0.2112,0.224 -0.3168,0.5472 -0.3168,0.9696v2.9376h-1.344v-7.104h1.344v2.448c0.1728,-0.2304 0.4032,-0.4096 0.6912,-0.5376c0.288,-0.1344 0.608,-0.2016 0.96,-0.2016zM28.3395,4.6816v5.3184h-1.3536v-0.672c-0.1728,0.2304 -0.4001,0.4128 -0.6816,0.5472c-0.2752,0.128 -0.576,0.192 -0.9025,0.192c-0.416,0 -0.784,-0.0864 -1.104,-0.2592c-0.32,-0.1792 -0.5728,-0.4384 -0.7584,-0.7776c-0.1791,-0.3456 -0.2687,-0.7552 -0.2687,-1.2288v-3.12h1.344v2.928c0,0.4224 0.1056,0.7488 0.3167,0.9792c0.2113,0.224 0.4993,0.336 0.8641,0.336c0.3712,0 0.6623,-0.112 0.8736,-0.336c0.2112,-0.2304 0.3168,-0.5568 0.3168,-0.9792v-2.928zM31.0095,5.4592c0.1728,-0.256 0.4096,-0.464 0.7104,-0.624c0.3072,-0.16 0.656,-0.24 1.0464,-0.24c0.4544,0 0.864,0.112 1.2288,0.336c0.3712,0.224 0.6624,0.544 0.8736,0.96c0.2176,0.4096 0.3264,0.8864 0.3264,1.4304c0,0.544 -0.1088,1.0272 -0.3264,1.4496c-0.2112,0.416 -0.5024,0.7392 -0.8736,0.9696c-0.3648,0.2304 -0.7744,0.3456 -1.2288,0.3456c-0.3968,0 -0.7456,-0.0768 -1.0464,-0.2304c-0.2944,-0.16 -0.5312,-0.3648 -0.7104,-0.6144v0.7584h-1.344v-7.104h1.344zM33.8223,7.3216c0,-0.32 -0.0672,-0.5952 -0.2016,-0.8256c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2112,-0.1216 -0.4416,-0.1824 -0.6912,-0.1824c-0.2432,0 -0.4736,0.064 -0.6912,0.192c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2368 -0.192,0.5152 -0.192,0.8352c0,0.32 0.064,0.5984 0.192,0.8352c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.1216 0.448,0.1824 0.6912,0.1824c0.2496,0 0.48,-0.064 0.6912,-0.192c0.2176,-0.128 0.3904,-0.3104 0.5184,-0.5472c0.1344,-0.2368 0.2016,-0.5184 0.2016,-0.8448zM38.207,10.0864c-0.4352,0 -0.8256,-0.0768 -1.1712,-0.2304c-0.3456,-0.16 -0.6208,-0.3744 -0.8256,-0.6432c-0.1984,-0.2688 -0.3072,-0.5664 -0.3264,-0.8928h1.3536c0.0256,0.2048 0.1248,0.3744 0.2976,0.5088c0.1792,0.1344 0.4,0.2016 0.6624,0.2016c0.256,0 0.4544,-0.0512 0.5952,-0.1536c0.1472,-0.1024 0.2208,-0.2336 0.2208,-0.3936c0,-0.1728 -0.0896,-0.3008 -0.2688,-0.384c-0.1728,-0.0896 -0.4512,-0.1856 -0.8352,-0.288c-0.3968,-0.096 -0.7232,-0.1952 -0.9792,-0.2976c-0.2496,-0.1024 -0.4672,-0.2592 -0.6528,-0.4704c-0.1792,-0.2112 -0.2688,-0.496 -0.2688,-0.8544c0,-0.2944 0.0832,-0.5632 0.2496,-0.8064c0.1728,-0.2432 0.416,-0.4352 0.7296,-0.576c0.32,-0.1408 0.6944,-0.2112 1.1232,-0.2112c0.6336,0 1.1392,0.16 1.5168,0.48c0.3776,0.3136 0.5856,0.7392 0.624,1.2768h-1.2864c-0.0192,-0.2112 -0.1088,-0.3776 -0.2688,-0.4992c-0.1536,-0.128 -0.3616,-0.192 -0.624,-0.192c-0.2432,0 -0.432,0.0448 -0.5664,0.1344c-0.128,0.0896 -0.192,0.2144 -0.192,0.3744c0,0.1792 0.0896,0.3168 0.2688,0.4128c0.1792,0.0896 0.4576,0.1824 0.8352,0.2784c0.384,0.096 0.7008,0.1952 0.9504,0.2976c0.2496,0.1024 0.464,0.2624 0.6432,0.48c0.1856,0.2112 0.2816,0.4928 0.288,0.8448c0,0.3072 -0.0864,0.5824 -0.2592,0.8256c-0.1664,0.2432 -0.4096,0.4352 -0.7296,0.576c-0.3136,0.1344 -0.6816,0.2016 -1.104,0.2016z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2903917600_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017453292520723307,0.9999999999984769,-0.9999999999984769,0.0000017453292520723307,220.2002,109.5615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2903917600",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2903917600_stroke_path",
    d: "M5.37849,0l-5.37849,5.4l5.37849,5.4",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2903917600_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7056942444350942,-0.7085165018340656,0.7085165018340656,0.7056942444350942,5.37849,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7056942444350937,0.7085165018340661,-0.7085165018340661,0.7056942444350937,5.37849,10.8)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -6.5785,
    y: -12,
    width: 19.735500000000002,
    height: 36,
    fill: "url(#m6evuu2903917600ps0)",
    mask: "url(#m6evuu2903917600_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2a47272766_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.2246467991473532e-16,1.2246467991473532e-16,-1,174.5996,64.1426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2a47272766",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2a47272766_stroke_path",
    d: "M5.4,0l-5.4,5.37849l5.4,5.37849",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2a47272766_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7085165018340659,-0.7056942444350939,0.7056942444350939,0.7085165018340659,5.4,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7085165018340661,0.7056942444350938,-0.7056942444350938,0.7085165018340661,5.4,10.75698)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -6.6000000000000005,
    y: -11.956999999999999,
    width: 19.8,
    height: 35.870999999999995,
    fill: "url(#m6evuu2a47272766ps0)",
    mask: "url(#m6evuu2a47272766_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2b77917485_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,47.3994,94.6211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2b77917485",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2b77917485_stroke_path",
    d: "M5.37849,0l-5.37849,5.4l5.37849,5.4",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2b77917485_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7056942444350942,-0.7085165018340656,0.7085165018340656,0.7056942444350942,5.37849,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7056942444350937,0.7085165018340661,-0.7085165018340661,0.7056942444350937,5.37849,10.8)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -6.5785,
    y: -12,
    width: 19.735500000000002,
    height: 36,
    fill: "url(#m6evuu2b77917485ps0)",
    mask: "url(#m6evuu2b77917485_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2c71701524_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.626655766248041,-0.7817327936245738,0.7782362940576895,-0.6249420795902096,120.2695,140.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2c71701524",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2c71701524_stroke_path",
    d: "M5.3869,0l-5.3869,5.3916l5.3869,5.3916",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2c71701524_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.706798377777389,-0.7074150501447162,0.7074150501447162,0.706798377777389,5.3869,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7067983777773891,0.7074150501447162,-0.7074150501447162,0.7067983777773891,5.3869,10.7832)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -6.5869,
    y: -11.9832,
    width: 19.7607,
    height: 35.949600000000004,
    fill: "url(#m6evuu2c71701524ps0)",
    mask: "url(#m6evuu2c71701524_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2c70788921_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.2246467991473532e-16,1.2246467991473532e-16,-1,342.5996,64.1426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2c70788921",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2c70788921_stroke_path",
    d: "M5.4,0l-5.4,5.37849l5.4,5.37849",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2c70788921_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7085165018340659,-0.7056942444350939,0.7056942444350939,0.7085165018340659,5.4,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.3,0c0,-0.16569 0.13431,-0.3 0.3,-0.3c0.16569,0 0.3,0.13431 0.3,0.3c0,0.16569 -0.13431,0.3 -0.3,0.3c-0.16569,0 -0.3,-0.13431 -0.3,-0.3z",
    transform: "matrix(0.7085165018340661,0.7056942444350938,-0.7056942444350938,0.7085165018340661,5.4,10.75698)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -6.6000000000000005,
    y: -11.956999999999999,
    width: 19.8,
    height: 35.870999999999995,
    fill: "url(#m6evuu2c70788921ps0)",
    mask: "url(#m6evuu2c70788921_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2d39912206_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,52.7998,58.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2d39912206",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2d39912206_stroke_path",
    d: "M0,0v172.11156",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2d39912206_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1.2,
    y: -173.3116,
    width: 3.5999999999999996,
    height: 519.9348,
    fill: "url(#m6evuu2d39912206ps0)",
    mask: "url(#m6evuu2d39912206_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2d81712966_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,54,57.8679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2d81712966",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2d81712966_stroke_path",
    d: "M0,0c0,0 79.7908,89.5921 79.8366,89.6436c0.0458,0.0515 0.0873,0.0954 0.1331,0.1469c0.0458,0.0515 0.0873,0.0956 0.1344,0.1459c0.0471,0.0503 0.0885,0.0943 0.1356,0.1446c0.0471,0.0503 0.0898,0.0933 0.1382,0.1425c0.0484,0.0492 81.9221,83.6809 81.9221,83.6809",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2d81712966_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -163.5,
    y: -175.1044,
    width: 490.5,
    height: 525.3132,
    fill: "url(#m6evuu2d81712966ps0)",
    mask: "url(#m6evuu2d81712966_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2e42448920_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.3994,52.7883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2e42448920",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2e42448920_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2e32643202_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,13.2002,113.1473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2e32643202",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2e32643202_fill_path",
    d: "M12.3703,0h55.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-55.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(4, 106, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6evuu2e32643202_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2e32643202_stroke_path",
    d: "M12.3703,0h55.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-55.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6evuu2e32643202_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2e32643202_stroke_path",
    d: "M12.3703,0h55.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-55.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2e32643202_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -80.39999999999999,
    y: -25.340600000000002,
    width: 241.2,
    height: 76.02180000000001,
    fill: "url(#m6evuu2e32643202ps0)",
    mask: "url(#m6evuu2e32643202_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2e08270350_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2e08270350",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2e08270350_fill_path",
    d: "M2.02984,3.2992v6.7008h-1.344v-6.7008zM8.24411,5.3728c0,0.3584 -0.0864,0.6944 -0.2592,1.008c-0.1664,0.3136 -0.432,0.5664 -0.7968,0.7584c-0.3584,0.192 -0.8128,0.288 -1.3632,0.288h-1.1232v2.5728h-1.344v-6.7008h2.4672c0.5184,0 0.96,0.0896 1.3248,0.2688c0.3648,0.1792 0.6368,0.4256 0.816,0.7392c0.1856,0.3136 0.2784,0.6688 0.2784,1.0656zM5.76731,6.3424c0.3712,0 0.6464,-0.0832 0.8256,-0.2496c0.1792,-0.1728 0.2688,-0.4128 0.2688,-0.72c0,-0.6528 -0.3648,-0.9792 -1.0944,-0.9792h-1.0656v1.9488zM15.5946,8.7232h-2.6688l-0.4416,1.2768h-1.4112l2.4096,-6.7104h1.5648l2.4096,6.7104h-1.4208zM15.2298,7.648l-0.9696,-2.8032l-0.9696,2.8032zM18.0121,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM22.1977,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM24.5184,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM28.704,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM32.7142,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM40.1955,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM38.8035,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM43.2117,10.0864c-0.4352,0 -0.8256,-0.0768 -1.1712,-0.2304c-0.3456,-0.16 -0.6208,-0.3744 -0.8256,-0.6432c-0.1984,-0.2688 -0.3072,-0.5664 -0.3264,-0.8928h1.3536c0.0256,0.2048 0.1248,0.3744 0.2976,0.5088c0.1792,0.1344 0.4,0.2016 0.6624,0.2016c0.256,0 0.4544,-0.0512 0.5952,-0.1536c0.1472,-0.1024 0.2208,-0.2336 0.2208,-0.3936c0,-0.1728 -0.0896,-0.3008 -0.2688,-0.384c-0.1728,-0.0896 -0.4512,-0.1856 -0.8352,-0.288c-0.3968,-0.096 -0.7232,-0.1952 -0.9792,-0.2976c-0.2496,-0.1024 -0.4672,-0.2592 -0.6528,-0.4704c-0.1792,-0.2112 -0.2688,-0.496 -0.2688,-0.8544c0,-0.2944 0.0832,-0.5632 0.2496,-0.8064c0.1728,-0.2432 0.416,-0.4352 0.7296,-0.576c0.32,-0.1408 0.6944,-0.2112 1.1232,-0.2112c0.6336,0 1.1392,0.16 1.5168,0.48c0.3776,0.3136 0.5856,0.7392 0.624,1.2768h-1.2864c-0.0192,-0.2112 -0.1088,-0.3776 -0.2688,-0.4992c-0.1536,-0.128 -0.3616,-0.192 -0.624,-0.192c-0.2432,0 -0.432,0.0448 -0.5664,0.1344c-0.128,0.0896 -0.192,0.2144 -0.192,0.3744c0,0.1792 0.0896,0.3168 0.2688,0.4128c0.1792,0.0896 0.4576,0.1824 0.8352,0.2784c0.384,0.096 0.7008,0.1952 0.9504,0.2976c0.2496,0.1024 0.464,0.2624 0.6432,0.48c0.1856,0.2112 0.2816,0.4928 0.288,0.8448c0,0.3072 -0.0864,0.5824 -0.2592,0.8256c-0.1664,0.2432 -0.4096,0.4352 -0.7296,0.576c-0.3136,0.1344 -0.6816,0.2016 -1.104,0.2016zM48.4429,10.0864c-0.4352,0 -0.8256,-0.0768 -1.1712,-0.2304c-0.3456,-0.16 -0.6208,-0.3744 -0.8256,-0.6432c-0.1984,-0.2688 -0.3072,-0.5664 -0.3264,-0.8928h1.3536c0.0256,0.2048 0.1248,0.3744 0.2976,0.5088c0.1792,0.1344 0.4,0.2016 0.6624,0.2016c0.256,0 0.4544,-0.0512 0.5952,-0.1536c0.1472,-0.1024 0.2208,-0.2336 0.2208,-0.3936c0,-0.1728 -0.0896,-0.3008 -0.2688,-0.384c-0.1728,-0.0896 -0.4512,-0.1856 -0.8352,-0.288c-0.3968,-0.096 -0.7232,-0.1952 -0.9792,-0.2976c-0.2496,-0.1024 -0.4672,-0.2592 -0.6528,-0.4704c-0.1792,-0.2112 -0.2688,-0.496 -0.2688,-0.8544c0,-0.2944 0.0832,-0.5632 0.2496,-0.8064c0.1728,-0.2432 0.416,-0.4352 0.7296,-0.576c0.32,-0.1408 0.6944,-0.2112 1.1232,-0.2112c0.6336,0 1.1392,0.16 1.5168,0.48c0.3776,0.3136 0.5856,0.7392 0.624,1.2768h-1.2864c-0.0192,-0.2112 -0.1088,-0.3776 -0.2688,-0.4992c-0.1536,-0.128 -0.3616,-0.192 -0.624,-0.192c-0.2432,0 -0.432,0.0448 -0.5664,0.1344c-0.128,0.0896 -0.192,0.2144 -0.192,0.3744c0,0.1792 0.0896,0.3168 0.2688,0.4128c0.1792,0.0896 0.4576,0.1824 0.8352,0.2784c0.384,0.096 0.7008,0.1952 0.9504,0.2976c0.2496,0.1024 0.464,0.2624 0.6432,0.48c0.1856,0.2112 0.2816,0.4928 0.288,0.8448c0,0.3072 -0.0864,0.5824 -0.2592,0.8256c-0.1664,0.2432 -0.4096,0.4352 -0.7296,0.576c-0.3136,0.1344 -0.6816,0.2016 -1.104,0.2016z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2g41379365_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,25.2002,197.4099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2g41379365",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2g41379365_fill_path",
    d: "M12.3703,0h29.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-29.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(4, 106, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6evuu2g41379365_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2g41379365_stroke_path",
    d: "M12.3703,0h29.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-29.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6evuu2g41379365_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2g41379365_stroke_path",
    d: "M12.3703,0h29.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-29.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2g41379365_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -54.4,
    y: -25.340600000000002,
    width: 163.2,
    height: 76.02180000000001,
    fill: "url(#m6evuu2g41379365ps0)",
    mask: "url(#m6evuu2g41379365_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2h46328428_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2h46328428",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2h46328428_fill_path",
    d: "M5.65036,5.3728c0,0.3584 -0.0864,0.6944 -0.2592,1.008c-0.1664,0.3136 -0.432,0.5664 -0.7968,0.7584c-0.3584,0.192 -0.8128,0.288 -1.3632,0.288h-1.1232v2.5728h-1.344v-6.7008h2.4672c0.5184,0 0.96,0.0896 1.3248,0.2688c0.3648,0.1792 0.6368,0.4256 0.816,0.7392c0.1856,0.3136 0.2784,0.6688 0.2784,1.0656zM3.17356,6.3424c0.3712,0 0.6464,-0.0832 0.8256,-0.2496c0.1792,-0.1728 0.2688,-0.4128 0.2688,-0.72c0,-0.6528 -0.3648,-0.9792 -1.0944,-0.9792h-1.0656v1.9488zM8.96619,10.0864c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4096,-0.2304 -0.7328,-0.5536 -0.9696,-0.9696c-0.2304,-0.416 -0.3456,-0.896 -0.3456,-1.44c0,-0.544 0.1184,-1.024 0.3552,-1.44c0.2432,-0.416 0.5728,-0.736 0.9888,-0.96c0.416,-0.2304 0.88,-0.3456 1.392,-0.3456c0.512,0 0.976,0.1152 1.39201,0.3456c0.416,0.224 0.7424,0.544 0.9792,0.96c0.2432,0.416 0.3648,0.896 0.3648,1.44c0,0.544 -0.1248,1.024 -0.3744,1.44c-0.2432,0.416 -0.576,0.7392 -0.9984,0.9696c-0.41601,0.224 -0.88321,0.336 -1.40161,0.336zM8.96619,8.9152c0.2432,0 0.4704,-0.0576 0.6816,-0.1728c0.2176,-0.1216 0.39041,-0.3008 0.51841,-0.5376c0.128,-0.2368 0.192,-0.5248 0.192,-0.864c0,-0.5056 -0.1344,-0.8928 -0.40321,-1.1616c-0.2624,-0.2752 -0.5856,-0.4128 -0.9696,-0.4128c-0.384,0 -0.7072,0.1376 -0.9696,0.4128c-0.256,0.2688 -0.384,0.656 -0.384,1.1616c0,0.5056 0.1248,0.896 0.3744,1.1712c0.256,0.2688 0.576,0.4032 0.96,0.4032zM14.0705,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM18.1725,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM22.3648,10.0864c-0.4352,0 -0.8256,-0.0768 -1.1712,-0.2304c-0.3456,-0.16 -0.6208,-0.3744 -0.8256,-0.6432c-0.1984,-0.2688 -0.3072,-0.5664 -0.3264,-0.8928h1.3536c0.0256,0.2048 0.1248,0.3744 0.2976,0.5088c0.1792,0.1344 0.4,0.2016 0.6624,0.2016c0.256,0 0.4544,-0.0512 0.5952,-0.1536c0.1472,-0.1024 0.2208,-0.2336 0.2208,-0.3936c0,-0.1728 -0.0896,-0.3008 -0.2688,-0.384c-0.1728,-0.0896 -0.4512,-0.1856 -0.8352,-0.288c-0.3968,-0.096 -0.7232,-0.1952 -0.9792,-0.2976c-0.2496,-0.1024 -0.4672,-0.2592 -0.6528,-0.4704c-0.1792,-0.2112 -0.2688,-0.496 -0.2688,-0.8544c0,-0.2944 0.0832,-0.5632 0.2496,-0.8064c0.1728,-0.2432 0.416,-0.4352 0.7296,-0.576c0.32,-0.1408 0.6944,-0.2112 1.1232,-0.2112c0.6336,0 1.1392,0.16 1.5168,0.48c0.3776,0.3136 0.5856,0.7392 0.624,1.2768h-1.2864c-0.0192,-0.2112 -0.1088,-0.3776 -0.2688,-0.4992c-0.1536,-0.128 -0.3616,-0.192 -0.624,-0.192c-0.2432,0 -0.432,0.0448 -0.5664,0.1344c-0.128,0.0896 -0.192,0.2144 -0.192,0.3744c0,0.1792 0.0896,0.3168 0.2688,0.4128c0.1792,0.0896 0.4576,0.1824 0.8352,0.2784c0.384,0.096 0.7008,0.1952 0.9504,0.2976c0.2496,0.1024 0.464,0.2624 0.6432,0.48c0.1856,0.2112 0.2816,0.4928 0.288,0.8448c0,0.3072 -0.0864,0.5824 -0.2592,0.8256c-0.1664,0.2432 -0.4096,0.4352 -0.7296,0.576c-0.3136,0.1344 -0.6816,0.2016 -1.104,0.2016z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2i48311184_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,168.5996,192.6299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2i48311184",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2i48311184_fill_path",
    d: "M12.3703,0h64.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-64.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(4, 106, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6evuu2i48311184_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2i48311184_stroke_path",
    d: "M12.3703,0h64.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-64.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6evuu2i48311184_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2i48311184_stroke_path",
    d: "M12.3703,0h64.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-64.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6evuu2i48311184_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -89.39999999999999,
    y: -25.340600000000002,
    width: 268.2,
    height: 76.02180000000001,
    fill: "url(#m6evuu2i48311184ps0)",
    mask: "url(#m6evuu2i48311184_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2i30667623_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2i30667623",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2i30667623_fill_path",
    d: "M3.37444,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.2512,0.1696 1.68,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.0656,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.3584,0.1792 -0.784,0.2688 -1.2768,0.2688zM11.9316,4.6816v5.3184h-1.3536v-0.672c-0.1728,0.2304 -0.4,0.4128 -0.68156,0.5472c-0.2752,0.128 -0.576,0.192 -0.9024,0.192c-0.416,0 -0.784,-0.0864 -1.104,-0.2592c-0.32,-0.1792 -0.5728,-0.4384 -0.7584,-0.7776c-0.1792,-0.3456 -0.2688,-0.7552 -0.2688,-1.2288v-3.12h1.344v2.928c0,0.4224 0.1056,0.7488 0.3168,0.9792c0.2112,0.224 0.4992,0.336 0.864,0.336c0.3712,0 0.66236,-0.112 0.87356,-0.336c0.2112,-0.2304 0.3168,-0.5568 0.3168,-0.9792v-2.928zM14.6017,5.4592c0.1728,-0.256 0.4096,-0.464 0.7104,-0.624c0.3072,-0.16 0.656,-0.24 1.0464,-0.24c0.4544,0 0.864,0.112 1.2288,0.336c0.3712,0.224 0.6624,0.544 0.8736,0.96c0.2176,0.4096 0.3264,0.8864 0.3264,1.4304c0,0.544 -0.1088,1.0272 -0.3264,1.4496c-0.2112,0.416 -0.5024,0.7392 -0.8736,0.9696c-0.3648,0.2304 -0.7744,0.3456 -1.2288,0.3456c-0.3968,0 -0.7456,-0.0768 -1.0464,-0.2304c-0.2944,-0.16 -0.5312,-0.3648 -0.7104,-0.6144v0.7584h-1.344v-7.104h1.344zM17.4145,7.3216c0,-0.32 -0.0672,-0.5952 -0.2016,-0.8256c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2112,-0.1216 -0.4416,-0.1824 -0.6912,-0.1824c-0.2432,0 -0.4736,0.064 -0.6912,0.192c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2368 -0.192,0.5152 -0.192,0.8352c0,0.32 0.064,0.5984 0.192,0.8352c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.1216 0.448,0.1824 0.6912,0.1824c0.2496,0 0.48,-0.064 0.6912,-0.192c0.2176,-0.128 0.3904,-0.3104 0.5184,-0.5472c0.1344,-0.2368 0.2016,-0.5184 0.2016,-0.8448zM21.7059,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM25.8915,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM30.9193,10.0864c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4096,-0.2304 -0.7328,-0.5536 -0.9696,-0.9696c-0.2304,-0.416 -0.3456,-0.896 -0.3456,-1.44c0,-0.544 0.1184,-1.024 0.3552,-1.44c0.2432,-0.416 0.5728,-0.736 0.9888,-0.96c0.416,-0.2304 0.88,-0.3456 1.392,-0.3456c0.512,0 0.976,0.1152 1.392,0.3456c0.416,0.224 0.7424,0.544 0.9792,0.96c0.2432,0.416 0.3648,0.896 0.3648,1.44c0,0.544 -0.1248,1.024 -0.3744,1.44c-0.2432,0.416 -0.576,0.7392 -0.9984,0.9696c-0.416,0.224 -0.8832,0.336 -1.4016,0.336zM30.9193,8.9152c0.2432,0 0.4704,-0.0576 0.6816,-0.1728c0.2176,-0.1216 0.3904,-0.3008 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5248 0.192,-0.864c0,-0.5056 -0.1344,-0.8928 -0.4032,-1.1616c-0.2624,-0.2752 -0.5856,-0.4128 -0.9696,-0.4128c-0.384,0 -0.7072,0.1376 -0.9696,0.4128c-0.256,0.2688 -0.384,0.656 -0.384,1.1616c0,0.5056 0.1248,0.896 0.3744,1.1712c0.256,0.2688 0.576,0.4032 0.96,0.4032zM41.2844,4.6048c0.6528,0 1.1776,0.2016 1.5744,0.6048c0.4032,0.3968 0.6048,0.9536 0.6048,1.6704v3.12h-1.344v-2.9376c0,-0.416 -0.1056,-0.7328 -0.3168,-0.9504c-0.2112,-0.224 -0.4992,-0.336 -0.864,-0.336c-0.3648,0 -0.656,0.112 -0.8736,0.336c-0.2112,0.2176 -0.3168,0.5344 -0.3168,0.9504v2.9376h-1.344v-2.9376c0,-0.416 -0.1056,-0.7328 -0.3168,-0.9504c-0.2112,-0.224 -0.4992,-0.336 -0.864,-0.336c-0.3712,0 -0.6656,0.112 -0.8832,0.336c-0.2112,0.2176 -0.3168,0.5344 -0.3168,0.9504v2.9376h-1.344v-5.3184h1.344v0.6432c0.1728,-0.224 0.3936,-0.4 0.6624,-0.528c0.2752,-0.128 0.576,-0.192 0.9024,-0.192c0.416,0 0.7872,0.0896 1.1136,0.2688c0.3264,0.1728 0.5792,0.4224 0.7584,0.7488c0.1728,-0.3072 0.4224,-0.5536 0.7488,-0.7392c0.3328,-0.1856 0.6912,-0.2784 1.0752,-0.2784zM44.3934,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM48.579,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM51.9268,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM52.5892,4.6816v5.3184h-1.344v-5.3184zM56.8643,4.6048c0.6336,0 1.1456,0.2016 1.536,0.6048c0.3904,0.3968 0.5856,0.9536 0.5856,1.6704v3.12h-1.344v-2.9376c0,-0.4224 -0.1056,-0.7456 -0.3168,-0.9696c-0.2112,-0.2304 -0.4992,-0.3456 -0.864,-0.3456c-0.3712,0 -0.6656,0.1152 -0.8832,0.3456c-0.2112,0.224 -0.3168,0.5472 -0.3168,0.9696v2.9376h-1.344v-5.3184h1.344v0.6624c0.1792,-0.2304 0.4064,-0.4096 0.6816,-0.5376c0.2816,-0.1344 0.5888,-0.2016 0.9216,-0.2016z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2k75434873_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,210,224.9006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2k75434873",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2k75434873_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2l23091286_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.3994,142.4296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2l23091286",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2l23091286_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2l44841137_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.3994,225.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6evuu2l44841137",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6evuu2l44841137_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))))))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1s46404786_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 329.967;0 329.967;0 329.967;0 329.967;29.305 300.662;80.1722 249.7948;172.3343 157.6328;254.7607 75.2063;292.2332 37.7339;311.0837 18.8833;320.9501 9.0169;325.5566 4.4105;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267;326.7 3.267",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1s46404786_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1t80347688_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 247.5006;0 247.5006;0 247.5006;0 247.5006;0 247.5006;225.25 22.2505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505;245.0501 2.4505",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1t80347688_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-245.0501;-245.0501;-245.0501;-245.0501;-245.0501;-19.8;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1u68412522",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.16;0.19;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1u09968821",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.22;0.23;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1v39981421",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.35;0.4;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1w06856334",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.28;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu1w24755581",
    attributeName: "opacity",
    values: "0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.08;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2108062960",
    attributeName: "opacity",
    values: "0;0;1;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.19;0.19;0.19;0.2;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2329438177",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.22;0.23;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2576020773",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.26;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate13 || (_animate13 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2767202312",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.37;0.38;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate14 || (_animate14 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2903917600",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.19;0.2;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate15 || (_animate15 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2a47272766",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.21;0.21;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate16 || (_animate16 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2b77917485",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.12;0.12;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate17 || (_animate17 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2c71701524",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.14;0.15;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate18 || (_animate18 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2c70788921",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.29;0.32;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate19 || (_animate19 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2d39912206_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 173.8327;0 173.8327;0 173.8327;35.8336 137.999;165.0894 8.7433;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211;172.1116 1.7211",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate20 || (_animate20 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2d39912206_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate21 || (_animate21 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2d81712966_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 240.3194;0 240.3194;0 240.3194;22.3188 218.0007;208.0786 32.2409;237.7735 2.546;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794;237.94 2.3794",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate22 || (_animate22 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2d81712966_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate23 || (_animate23 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2e42448920",
    attributeName: "opacity",
    values: "0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.05;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate24 || (_animate24 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2e32643202",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.11;0.19;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate25 || (_animate25 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2g41379365",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.16;0.24;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate26 || (_animate26 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2i48311184",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.17;0.21;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate27 || (_animate27 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2k75434873",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.17;0.2;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate28 || (_animate28 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2l23091286",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.12;0.18;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate29 || (_animate29 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6evuu2l44841137",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.19;0.24;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconnaissanceMotion);
export default __webpack_public_path__ + "static/media/reconnaissance-motion.00b1207b997cb3a4b1eab6f9c7ca3fe5.svg";
export { ForwardRef as ReactComponent };